import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH, MOBILE_WIDTH } from '../../constants/dims';
import imgStressFree from '../../assets/img/stressFree.png';
import { withRouter } from 'react-router-dom';
import PreferencesContext from '../../contexts/preferences';
import LaunchGame from "./LaunchGame";

const Section = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  color: ${props => props.theme.stressFree.text};
  background-color: ${props => props.theme.stressFree.backgroundColor};
  padding: 32px;
  box-sizing: border-box;
`;

const Container = styled.div`
  width: 100%;
  max-width: ${TABLET_WIDTH}px;
  text-align: center;
`;

const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  & > div {
    max-width: 840px;
    text-align: center;
  }
`;

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
`;

const Column = styled.div`
  flex: 1 1 375px;
  min-width: 375px;
  text-align: left;
  box-sizing: border-box;
  margin-bottom: 24px;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    min-width: 0;
  }

  &:last-child {
    padding-left: 24px;
    margin-bottom: 0px;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      padding-left: 0;
    }
  }
`;

const Header = styled.div`
  padding: 20px;
  box-sizing: border-box;
`;

const StressFree = withRouter(({ history }) => {
  const { inGame } = useContext(PreferencesContext);

  return (
    <Section id="stress-free">
      <Container>
        <Header>
          <h2>We use science to make math more fun</h2>
          <h5>
            Decades of research show all children are perfectly capable of
            mastering mathematics.
          </h5>
        </Header>
        <ImgWrapper>
          <div>
            <img src={imgStressFree} alt="" />
          </div>
        </ImgWrapper>
        <Columns>
          <Column>
            <h4>The ultimate math problem</h4>
            <p>
              We call this problem the <i>Symbol Barrier</i>&trade; and our
              puzzles are proven to overcome it.
            </p>
          </Column>

          <Column>
            <h4>A stress-free learning environment</h4>
            <p>
              Our puzzles create stress-free problem-solving challenges for
              people ages 8 and up. They’re like word problems without the
              words!
            </p>
          </Column>
        </Columns>

        {!inGame && <LaunchGame labelStyle={{ color: 'black' }} />}
      </Container>
    </Section>
  );
});

export default StressFree;
